//src/pages/wartung/Wartungsliste.jsx
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

export default function Wartungsliste() {
  const [liste, setListe] = useState([]);
  const navigate = useNavigate();

  useEffect(() => {
    async function load() {
      const res = await fetch(`${process.env.REACT_APP_API_URL}/api/wartungsprotokoll`);
      const data = await res.json();
      console.log("wartungsprotokoll response:", data);   // <– check browser console

      // if backend returns { content: [...] }
      // setListe(data.content || []);

      // if it *is* an array, keep this:
      setListe(Array.isArray(data) ? data : []);
    }
    load();
  }, []);

  const handleDelete = async (id) => {
    const ok = window.confirm(
      "Bestätigung für Entfernen:\nMöchten Sie diesen Eintrag löschen?"
    );
    if (!ok) return;

    await fetch(`${process.env.REACT_APP_API_URL}/api/wartungsprotokoll/${id}`, {
      method: "DELETE",
    });

    setListe(prev => prev.filter(item => item.id !== id));
  };

  return (
    <div style={{ padding: "30px", maxWidth: "900px", margin: "0 auto" }}>
      <h1 style={{ fontSize: "22px", marginBottom: "20px" }}>
        Wartungsprotokolle – Liste
      </h1>

      {liste
        .filter(item => item.seite1?.anlagenbezeichnung?.trim())
        .map(item => (
          <div
            key={item.id}
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              padding: "18px 22px",
              marginBottom: "12px",
              background: "white",
              borderRadius: "10px",
              border: "1px solid #e0e0e0",
              boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
              transition: "0.2s",
            }}
            onMouseOver={(e) =>
              (e.currentTarget.style.boxShadow = "0 4px 12px rgba(0,0,0,0.12)")
            }
            onMouseOut={(e) =>
              (e.currentTarget.style.boxShadow = "0 2px 6px rgba(0,0,0,0.05)")
            }
          >
            {/* Name clickable */}
            <div
              onClick={() => navigate(`/wartung/protokoll/${item.id}`)}
              style={{
                cursor: "pointer",
                fontSize: "16px",
                color: "#0056d6",
                fontWeight: "500",
              }}
            >
              {item.seite1.anlagenbezeichnung}
            </div>

            {/* Buttons */}
            <div style={{ display: "flex", gap: "10px" }}>
              <button
                onClick={() => navigate(`/wartung/protokoll/${item.id}`)}
                style={{
                  padding: "6px 14px",
                  background: "#c9a000",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                Bearbeiten
              </button>

              <button
                onClick={() => handleDelete(item.id)}
                style={{
                  padding: "6px 14px",
                  background: "#d93025",
                  color: "white",
                  border: "none",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontSize: "13px",
                }}
              >
                Entfernen
              </button>
            </div>
          </div>
        ))}
    </div>
  );
}
